/* eslint-disable react-portal/no-react-router-use-navigate */
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useSessionStorage } from '../../utilities/StorageUtilities';
import { useDefaultPage } from '../side-nav/DefaultPage';
import { URL_TRACKER_COOKIE } from './AuthConstants';

export default function usePostLoginRedirect() {
    const location = useLocation();
    const navigate = useNavigate();
    const currentPath = `${location.pathname}${location.search}${location.hash}`;
    const { defaultPage } = useDefaultPage();
    const [lastLocation, setLastLocation] = useSessionStorage(URL_TRACKER_COOKIE);

    const saveCurrentLocation = useCallback(() => {
        setLastLocation(currentPath);
    }, [currentPath, setLastLocation]);

    const navigateToLastLocation = useCallback(() => {
        sessionStorage.removeItem(URL_TRACKER_COOKIE);
        navigate(lastLocation || defaultPage);
    }, [lastLocation, defaultPage, navigate]);

    const doAndRestoreLastLocation = useCallback(
        (workFn) => {
            workFn();
            setLastLocation(lastLocation);
        },
        [lastLocation, setLastLocation]
    );

    return { saveCurrentLocation, navigateToLastLocation, doAndRestoreLastLocation };
}
